<script lang="ts" setup>
import { ref } from "#imports";
import MPButton from "./MPButton.vue";
const toggleDropdown = ref(false);
const emit = defineEmits<{
  reset: [];
  apply: [];
}>();
const resetFilters = () => {
  emit("reset");
};

const applyFilters = () => {
  emit("apply");
  toggleDropdown.value = !toggleDropdown.value;
};
</script>

<template>
  <div class="toggle">
    <i class="ri-equalizer-2-line" @click="toggleDropdown = !toggleDropdown" />
    <div class="notification" />
    <Teleport to="#teleports">
      <div v-if="toggleDropdown" class="dropdown">
        <slot />
        <div class="controls">
          <MPButton
            version="secondary"
            size="small"
            label="Reset Filters"
            @click="resetFilters"
          />
          <MPButton label="Show Results" size="small" @click="applyFilters" />
        </div>
      </div>
    </Teleport>
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";

.toggle {
  width: fit-content;
  position: relative;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-slate-400);
  i {
    padding: 0.65rem 1rem;
  }
}

.notification {
  position: absolute;
  top: -0.25rem;
  right: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: var(--color-rose-500);
}

.dropdown {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: white;
  align-items: center;
  justify-content: center;
  z-index: 9000;
  padding: 1rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @mixin screen md {
    position: absolute;
    top: 30%;
    left: 50%;
    width: 30%;
    transform: translate(-50%, -50%);
    border-radius: 0.5rem;
    box-shadow: var(--shadow-md);
  }
}

.controls {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
